import { useRef, useState } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import moment from 'moment';

const ImageCropper = ({ isOpen, onClose, onCrop, imageType, memberID }) => {
    const cropperRef = useRef(null);
    const fileInputRef = useRef(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [fileName, setFileName] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const maxFileSize = 1000 * 1024;
            if (file.size > maxFileSize) {
                alert('업로드 파일의 사이즈는 1,000KB까지 가능합니다.');
                e.target.value = '';
                return;
            }
            const fileFormat = file.name.split('.').pop().toLowerCase();
            setFileName(`CP_${memberID}_${moment().format('YYYYMMDDHHmmss')}.${fileFormat}`);
            const reader = new FileReader();
            reader.onload = () => setImageSrc(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCrop = () => {
        if (!imageSrc) {
            alert('등록할 이미지가 없습니다.');
            return;
        }

        if (!window.confirm('미리보기 이미지에서 보이는 이미지대로 등록하시겠습니까?')) {
            return;
        }
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            const croppedCanvas = cropper.getCroppedCanvas({
                width: 130,
                height: 160,
                imageSmoothingQuality: 'high',
            });

            croppedCanvas.toBlob((blob) => {
                if (blob) {
                    const croppedImageUrl = URL.createObjectURL(blob);
                    const croppedFile = new File([blob], fileName);
                    onCrop(croppedImageUrl, croppedFile, imageType);
                    handleClose();
                }
            }, 1);
        }

        alert('변경되었습니다.');
    };

    const handleClose = () => {
        setImageSrc(null);
        setCroppedImage(null);
        setFileName('');
        if (fileInputRef.current) fileInputRef.current.value = '';
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="resume_picture">
                {/* Header */}
                <div className="modal-header border-0">
                    <h5 className="modal-title fw-bold">사진 올리기</h5>
                    <button type="button" className="btn-close" onClick={handleClose}></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                    {/* Instructions */}
                    <ol className="notice_box">
                        <li>
                            [파일 선택]을 클릭, 등록할 사진을 선택한 후, 이력서 및 회원정보에 첨부할 영역을 마우스로
                            드래그하여 선택해 주세요.
                        </li>
                        <li>이력서용 사진 칸에 원하는 사진 영역 선택이 완료되면 [등록]을 클릭해 주세요.</li>
                        <li>사진을 새로 등록 또는 변경하면 작성한 이력서에도 사진이 변경됩니다.</li>
                    </ol>

                    {/* Image Preview and Cropper */}
                    <div className="picture_box">
                        <div className="picture_before">
                            <h6 className="tit">원본사진</h6>
                            <div className="picture">
                                {imageSrc ? (
                                    <Cropper
                                        src={imageSrc}
                                        style={{ width: 250 }}
                                        aspectRatio={130 / 160}
                                        guides={true}
                                        viewMode={1}
                                        minCropBoxHeight={50}
                                        minCropBoxWidth={50}
                                        background={false}
                                        responsive={true}
                                        autoCropArea={130 / 160}
                                        checkOrientation={false}
                                        ref={cropperRef}
                                        preview={'.previewArea'}
                                    />
                                ) : (
                                    <span>편집할 사진을 등록해주세요</span>
                                )}
                            </div>
                        </div>
                        <div className="picture_after">
                            <h6 className="tit">이력서용 사진</h6>
                            <div className="picture">
                                <div className="img previewArea" style={{ width: 130, height: 160 }}>
                                    {croppedImage && <img src={croppedImage} alt="Cropped" className="img-fluid" />}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* File Input */}
                    <div className="file_box">
                        <input
                            type="file"
                            accept="image/jpeg,image/png,image/gif"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                    </div>
                    <p className="txt">・사진 파일은 1,000KB 이하의 JPG, JPEG, PNG, GIF 파일만 업로드 가능</p>
                    <p className="txt">・사진 크기는 130*160 픽셀로 노출됩니다.</p>
                </div>

                {/* Footer */}
                <div className="resume__btbx">
                    <button type="button" className="resume__btn" onClick={handleClose}>
                        취소
                    </button>
                    <button type="button" className="resume__btn resume__btn--blue" onClick={handleCrop}>
                        등록
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
